module.exports = __webpack_public_path__ + "static/keva-after.ef53a547.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/clients/keva-after.jpg
// module id = 156
// module chunks = 35783957827783 208176855801404